"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BottomSnackbarWithCloseButton = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var Slide_1 = tslib_1.__importDefault(require("@material-ui/core/Slide"));
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var utils_1 = require("../../../utils");
var icon_definitions_1 = require("../atoms/icon-definitions");
var TransitionUp = function (props) { return (react_1.default.createElement(Slide_1.default, tslib_1.__assign({}, props, { direction: 'up' }))); };
var Content = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var greenBgColorHsla = [123, 41, 45, 1];
exports.BottomSnackbarWithCloseButton = (0, react_1.memo)(function (_a) {
    var isOpen = _a.isOpen, onCloseClick = _a.onCloseClick, message = _a.message, _b = _a.textColor, textColor = _b === void 0 ? (0, utils_1.hslToHsla)(utils_1.whiteHsl) : _b, _c = _a.backgroundColor, backgroundColor = _c === void 0 ? greenBgColorHsla : _c, _d = _a.position, position = _d === void 0 ? 'left' : _d;
    var snackbarContentColor = (0, react_1.useMemo)(function () { return ({
        backgroundColor: (0, utils_1.hslaToStr)(backgroundColor),
        color: (0, utils_1.hslaToStr)(textColor)
    }); }, [backgroundColor, textColor]);
    var anchorOrigin = (0, react_1.useMemo)(function () { return ({
        vertical: 'bottom',
        horizontal: position
    }); }, [position]);
    return (react_1.default.createElement(core_1.Snackbar, { anchorOrigin: anchorOrigin, open: isOpen, TransitionComponent: TransitionUp },
        react_1.default.createElement(core_1.SnackbarContent, { style: snackbarContentColor, message: react_1.default.createElement(Content, null, message), action: [
                react_1.default.createElement(core_1.IconButton, { key: 'close', color: 'inherit', onClick: onCloseClick },
                    react_1.default.createElement(icon_definitions_1.CloseIcon, null))
            ] })));
});
exports.BottomSnackbarWithCloseButton.displayName = 'BottomSnackbarWithCloseButton';
var templateObject_1;
